import { DeliveryByEvent, Image, Link } from '@noths/polaris-dev-ts-types';

import { Partner, Price } from '.';

export interface SponsoredProductData {
  'data-elevaate-piid': string;
  'data-elevaate-aid': number;
  'data-elevaate-pid': number;
}

export type ProductPartner = Pick<Partner, 'name' | 'shortcode' | 'links'>;

export interface Product {
  available: boolean;
  code: number;
  freeDomesticDelivery: boolean;
  images: Image[];
  links: Link[];
  isNew: boolean;
  number_of_reviews: number;
  onSale: boolean;
  partner: ProductPartner;
  preSalePrices: Price[];
  price: Price;
  product_rating: string;
  salePercentage: number;
  title: string;
  isSponsored: boolean;
  sponsoredProductData?: SponsoredProductData;
  isLoading?: boolean;
  purchasable: boolean;
  deliveryByEvent?: Omit<DeliveryByEvent, 'lastDeliveryBy'>;
}

export interface DecoratedProductForDisplay extends Product {
  isFavourited: boolean;
}

export enum ProductsAPIPath {
  Category = 'listings/v1/category',
  Search = 'listings/v1/search',
  Partner = 'listings/v1/partner',
}

export type ProductUrlType = NonNullable<Link['rel']>;
